import {useEffect,useRef,useState} from 'react';
import {ApiError,importReviewedReferencePackage,ReferenceImportResult,reviewedReferenceRelease} from './api';

export function ProofReferenceAdministration(){
  const [confirmed,setConfirmed]=useState(false);
  const [pending,setPending]=useState(false);
  const [result,setResult]=useState<ReferenceImportResult|null>(null);
  const [failure,setFailure]=useState<'denied'|'disabled'|'unknown'|null>(null);
  const inFlight=useRef(false);
  const status=useRef<HTMLDivElement>(null);
  useEffect(()=>{if(result||failure)status.current?.focus();},[result,failure]);

  async function importPackage(){
    if(!confirmed||inFlight.current||result)return;
    inFlight.current=true;setPending(true);setFailure(null);
    try{setResult(await importReviewedReferencePackage());}
    catch(error){
      setFailure(error instanceof ApiError&&[401,403].includes(error.status)?'denied':error instanceof ApiError&&error.status===404?'disabled':'unknown');
      setConfirmed(false);
    }finally{inFlight.current=false;setPending(false);}
  }

  return <section className="panel" aria-labelledby="reference-administration-title">
    <p className="eyebrow">PROFENZ ADMINISTRATION</p>
    <h2 id="reference-administration-title">Court-reference package</h2>
    <p>Import the reviewed release package for later reference checks. This does not approve legal rules, prepare affidavits, or make the references available to customers.</p>
    <dl><dt>References in this release</dt><dd>{reviewedReferenceRelease.reference_count.toLocaleString('en-US')}</dd>
      <dt>Package fingerprint</dt><dd style={{overflowWrap:'anywhere'}}><code>{reviewedReferenceRelease.package_sha256}</code></dd></dl>
    {!result&&<>
      <p>Use your ProFenz executive account and a current security verification. Company administration and Platform Owner inspection access do not grant import permission.</p>
      <p><a className="button-link" href="/mfa?step_up=1">Verify my identity</a></p>
      <fieldset disabled={pending}>
        <label><input type="checkbox" checked={confirmed} onChange={event=>setConfirmed(event.target.checked)}/> I confirm this is the reviewed release package to import.</label>
        <button type="button" disabled={!confirmed||pending} onClick={importPackage}>{pending?'Confirming import…':failure==='unknown'?'Check or complete the same import':'Import reviewed package'}</button>
      </fieldset>
    </>}
    <div ref={status} tabIndex={-1} role="status" aria-live="polite" aria-atomic="true">
      {pending&&<p>Waiting for the import result. Keep this page open.</p>}
      {result&&<div className="notice"><h3>{result.created?'Reference package imported':'Reference package already imported'}</h3>
        <p>{result.reference_count.toLocaleString('en-US')} references confirmed. The fingerprint matches this release.</p>
        <p>Import receipt: <code>{result.package_id}</code></p><p>Customer availability remains a separate release step.</p></div>}
      {failure==='denied'&&<p className="notice error">Import is not authorized for this session. Use the ProFenz executive account and verify your identity, then return to Court-reference package. No permission was changed.</p>}
      {failure==='disabled'&&<p className="notice">Import is not enabled on this application revision. Contact the release administrator.</p>}
      {failure==='unknown'&&<p className="notice error">The result could not be confirmed. The package may already be saved. No automatic retry was made. Confirm the package again to check or complete the same import; an existing matching package is reused.</p>}
    </div>
  </section>;
}
